import { render, staticRenderFns } from "./ScheduledSnapshots.vue?vue&type=template&id=454cb2ba&scoped=true&"
import script from "./ScheduledSnapshots.vue?vue&type=script&lang=js&"
export * from "./ScheduledSnapshots.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledSnapshots.vue?vue&type=style&index=0&id=454cb2ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454cb2ba",
  null
  
)

export default component.exports